import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useUserSettingsStore } from '@/stores/userSettingsStore';
import { RagIndex } from '@/core/indexesEnum';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'sectionTitle',
  props: {
    section: {}
  },
  setup(__props: any) {

const PRODUCT_KEY_MAP: Record<number, string> = {
  [RagIndex.NAW]: 'naw',
  [RagIndex.CissContable]: 'ciss',
  [RagIndex.CissFiscal]: 'ciss',
  [RagIndex.CissLaboral]: 'ciss'
};

const props = __props;

const { t } = useI18n();
const userSettingsStore = useUserSettingsStore();

const productKey = computed(
  () => PRODUCT_KEY_MAP[userSettingsStore.selectedRagIndex as number]
);

const productSectionKey = computed(() =>
  productKey.value
    ? `legal_assistant.chat.sections.title.${productKey.value}.${props.section}`
    : ''
);
const defaultSectionKey = computed(
  () => `legal_assistant.chat.sections.title.${props.section}`
);

const text = computed(() => {
  const prod = t(productSectionKey.value);
  if (prod !== productSectionKey.value) return prod;
  const def = t(defaultSectionKey.value);
  if (def !== defaultSectionKey.value) return def;
  return props.section;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(text.value), 1))
}
}

})